<template lang="">
    <!-- <div>
      <v-btn text @click="seleccion(0)">Inicio</v-btn>
      <v-btn text @click="seleccion(1)">Principal</v-btn>
      <v-btn text @click="seleccion(2)">Reguladores</v-btn>
       <v-btn text @click="seleccion(2)">Reguladores 1</v-btn>
      <v-btn text @click="seleccion(3)">Reguladores 2</v-btn> 
    </div> -->
    <v-tabs align-with-title>
      <v-tab @click="seleccion(2)">Reguladores</v-tab>
      <v-tab @click="seleccion(1)">Principal</v-tab>
      <v-tab @click="seleccion(0)">Secadero</v-tab>
    </v-tabs>

</template>
<script>
export default {
  methods: {
    seleccion(a){
      console.log("Seleccionado",a)
      this.$emit('seleccion',a)  
    }
  },
    
}
</script>
<style lang="">
    
</style>